/* eslint-disable @typescript-eslint/no-explicit-any */
import { ref } from 'vue';
import EmailAction from './actionables/EmailAction.vue';
import type { WorkflowActionableType } from '@/api/entity_types/workflow/WorkflowDefinition';
import type { WorkflowActionableParams } from '@/api/entity_types/workflow/WorkflowAction';
import SmsAction from './actionables/SmsAction.vue';
import OneOffTaskAction from './actionables/OneOffTaskAction.vue';

export type ActionableExpose = {
  buildActionableParams: () => WorkflowActionableParams;
  resetFields: () => void;
};

export const useActionableComponentMap = () => {
  const actionableRef = ref<ActionableExpose | null>(null);

  const actionComponentMap = new Map<WorkflowActionableType, any>([
    ['WorkflowActionEmail', { component: EmailAction, ref: actionableRef }],
    ['WorkflowActionSms', { component: SmsAction, ref: actionableRef }],
    ['WorkflowActionOneOffTask', { component: OneOffTaskAction, ref: actionableRef }],
  ]);

  return actionComponentMap;
};
